import { render, staticRenderFns } from "./search-type.vue?vue&type=template&id=c37cedda&scoped=true"
import script from "./search-type.vue?vue&type=script&lang=js"
export * from "./search-type.vue?vue&type=script&lang=js"
import style0 from "./search-type.vue?vue&type=style&index=0&id=c37cedda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37cedda",
  null
  
)

export default component.exports